<template>
  <v-toolbar flat dense class="mb-5">
    <v-toolbar-title>
      {{ title }}
    </v-toolbar-title>

    <v-select
      :value="params.limit"
      :items="[10, 25, 50, 100]"
      label="Sor per oldal"
      class="mx-3"
      :style="{
        maxWidth: '6rem'
      }"
      dense
      outlined
      hide-details
      @change="limitChanged"
    ></v-select>

    <v-text-field
      v-model="_search"
      class="ml-5"
      label="Keresés"
      hide-details
      :style="{
        maxWidth: '15rem'
      }"
      @input="searchChanged"
    ></v-text-field>

    <template>
      <v-spacer></v-spacer>

      <v-btn
        v-if="userHasPermission(`create.${model}`)"
        color="primary"
        @click="SET_CREATE_MODAL(true)"
      >
        Új {{ entity }} létrehozása
      </v-btn>
    </template>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  SET_CREATE_MODAL,
  SET_LIMIT,
  SET_PAGE,
  SET_SEARCH
} from "../../../utils/constants";
export default {
  name: "TableTopToolbar",
  props: {
    title: {
      type: String,
      default: "Lista cím"
    },
    entity: {
      type: String,
      default: "Sor"
    },
    model: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("Table", ["params"]),
    ...mapGetters("Auth", ["userHasPermission"]),
    _search: {
      get() {
        return this.params.search;
      },
      set(value) {
        this.SET_SEARCH(value);
      }
    }
  },
  data() {
    return {
      time: null
    };
  },
  methods: {
    ...mapMutations("Table", [SET_SEARCH, SET_LIMIT, SET_PAGE]),
    ...mapMutations("Modal", [SET_CREATE_MODAL]),
    limitChanged(newLimit) {
      this.SET_LIMIT(newLimit);
      this.$emit("filter");
    },
    searchChanged(newSearch) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (newSearch == "") this.SET_SEARCH(null);

      this.timer = setTimeout(() => {
        this.SET_PAGE(1);
        this.SET_SEARCH(newSearch);
        this.$emit("filter");
      }, 800);
    }
  }
};
</script>
